<script setup lang="ts">
import { computed, useSlots } from "vue";

// export interface DiscountBadgeProps {}

const slotContentLength = computed(() => {
  const defaultSlot = useSlots().default?.();

  if (!defaultSlot || !defaultSlot[0]) {
    return 0;
  }

  const textContent = defaultSlot[0].children;
  return typeof textContent === "string" ? textContent.length : 0;
});
</script>

<template>
  <span
    class="bg-base-02 inline-flex items-center justify-center rounded-full text-center text-xs font-medium text-disabled-01"
    :class="{
      'h-9 w-9': slotContentLength > 0 && slotContentLength < 5,
      'h-11 w-11': slotContentLength > 4,
    }"
    role="status"
    data-testid="clr-discount-badge"
    ><slot
  /></span>
</template>
